import * as React from "react";
import { CtaButton } from "@components/RedesignComponents/Cta/cta-button";
import { navigate } from "gatsby";
import { Builder } from "@builder.io/react";
import { segmentTrack } from "@utils/segment/segment-track";

type PageModellink = {
  value: {
    data: {
      url: string;
    };
  };
};

// TODO: Import ButtonProps from UI instead of recreating them here.
interface ButtonProps {
  link: PageModellink;
  linkUrl: string;
  copy: string;
  variant:
    | "primarySun"
    | "primaryForest"
    | "secondarySun"
    | "secondaryForest"
    | "tertiarySun"
    | "tertiaryForest";
  copySize: "bodyRegular" | "bodyLarge" | "bodyExtraLarge";
  openInNewTab?: boolean;
}

const Cta = ({
  link,
  linkUrl,
  copy,
  variant,
  copySize,
  openInNewTab,
}: ButtonProps) => {
  const regularCta = ["tertiarySun", "tertiaryForest"].includes(variant);

  const buttonClickEvent: React.MouseEventHandler<HTMLAnchorElement> = e => {
    if (link) {
      e.preventDefault();
      navigate(link.value?.data?.url);
    }
    if (regularCta) {
      segmentTrack("Link Clicked", {
        url: window.location.pathname,
        text: copy,
        target: link?.value?.data?.url || linkUrl,
        action: "Clicked",
        initiator: "User",
        object: "Link",
        source_application: "Marketing",
      });
    } else {
      segmentTrack("Marketing CTA Clicked", {
        url: window.location.pathname,
        text: copy,
        target: link?.value?.data?.url || linkUrl,
        initiator: "User",
        object: "Marketing CTA",
        action: "Clicked",
        source_application: "Marketing",
      });
    }
  };

  return (
    <CtaButton
      link={link?.value?.data?.url}
      isDisabled={false}
      linkUrl={linkUrl}
      onClick={buttonClickEvent}
      copy={copy}
      variant={variant}
      copySize={copySize}
      openInNewTab={openInNewTab}
    />
  );
};

export default Cta;

export const RegisterCtaNew = () => {
  Builder.registerComponent(Cta, {
    name: "cta",
    inputs: [
      {
        name: "copy",
        type: "string",
        defaultValue: "",
        required: true,
      },
      {
        name: "copySize",
        type: "string",
        defaultValue: "bodyRegular",
        enum: ["bodyExtraLarge", "bodyLarge", "bodyRegular"],
        required: true,
      },
      {
        name: "openInNewTab",
        type: "boolean",
        defaultValue: false,
      },
      {
        name: "link",
        type: "reference",
        model: "page",
      },
      {
        name: "linkUrl",
        type: "string",
      },
      {
        name: "variant",
        type: "string",
        defaultValue: "primarySun",
        enum: [
          "primaryForest",
          "primarySun",
          "secondaryForest",
          "secondarySun",
          "tertiaryForest",
          "tertiarySun",
        ],
        required: true,
      },
    ],
  });
};
